import Icon from '../components/Icon';

const PartyPopper = Icon(
  'party-popper',
  <>
    <path d="M12.5 1.75a.75.75 0 0 1 .75.75v2.25a.75.75 0 0 1-1.5 0V2.5a.75.75 0 0 1 .75-.75M19.955 3.725c-.044.26-.132.618-.315.985-.507 1.014-1.525 1.54-2.64 1.54-.805 0-1.342.471-1.475 1.272a2 2 0 0 0-.025.233.75.75 0 0 1-.75.745c-.434 0-.763-.378-.75-.8.004-.076.012-.227.045-.425.087-.522.345-1.452 1.238-2.047.453-.302 1.023-.478 1.717-.478.55 0 1.044-.203 1.298-.71.12-.241.193-.52.202-.79a.76.76 0 0 1 .75-.75c.434 0 .763.378.749.8a3 3 0 0 1-.044.425M19.78 10.97a.75.75 0 1 0-1.06 1.06l1.5 1.5a.75.75 0 1 0 1.06-1.06zM22.212 7.513a.75.75 0 0 1-.475.948l-2.25.75a.75.75 0 0 1-.474-1.423l2.25-.75a.75.75 0 0 1 .948.475" />
    <path
      fillRule="evenodd"
      d="M6.987 6.522a1.5 1.5 0 0 1 2.47-.548l8.56 8.559a1.5 1.5 0 0 1-.546 2.47L4.017 21.921c-1.197.438-2.36-.723-1.925-1.92zm9.969 9.072-8.56-8.56-1.212 3.34 6.439 6.438zm-11.57-.269 1.233-3.395 5.45 5.45-3.389 1.24zm-.565 1.556 2.306 2.307-3.625 1.325z"
      clipRule="evenodd"
    />
  </>
);

export default PartyPopper;
